"use client";

import { Heading, Text, Box, Grid, GridItem, Link } from "@chakra-ui/react";
import { Card, HoverCardProps } from "@ui/components";
import Image from "next/image";
import { SectionTemplate } from "./individuals/blocks";
import { usePathname } from "next/navigation";

export interface ClientOfferingsSectionProps {
  title: string;
  subtitle: string;
  textColor: string;
  infoCards: Omit<HoverCardProps, "description" | "hoverDescription">[];
  bg: string;
}

export const ClientOfferingsSection = (props: ClientOfferingsSectionProps) => {
  const pathname = usePathname();
  return (
    <SectionTemplate bg={props.bg} color={props.textColor}>
      <Heading
        as={"h1"}
        fontSize={{
          base: 26,
          md: 34,
          lg: 38,
          xl: 45,
        }}
        lineHeight={1.2}
        fontWeight={"bold"}
        mb={{
          base: 8,
          lg: 12,
        }}
        textAlign={"left"}
        w={{
          lg: "80%",
        }}
      >
        {props.title}
      </Heading>
      <Heading
        as={"h2"}
        fontSize={{
          base: 16,
          md: 20,
          xl: 22,
        }}
        fontWeight={"semibold"}
        mb={{
          base: 0,
          lg: 14,
        }}
        textAlign={"left"}
        w={{
          lg: "85%",
        }}
      >
        {props.subtitle}
      </Heading>
      <Grid
        templateColumns={
          pathname === "/"
            ? { md: "repeat(3, 1fr)" }
            : {
                md: "repeat(3, 1fr)",
                lg: "repeat(4, 1fr)",
              }
        }
        gap={8}
        w="80%"
        mx={"auto"}
        mt={10}
      >
        {props.infoCards.map((card, index) => (
          <GridItem key={`offerings-section-grid-item-${index}`}>
            <Link
              href={card.url as string}
              _hover={{
                textDecoration: "none",
                textTransform: "none",
              }}
            >
              <Card
                flex="1"
                minW={0}
                alignContent="center"
                justifyContent="center"
                gap={4}
                p={{ base: 5, lg: 6 }}
                bgColor="white"
                borderRadius="xl"
                boxShadow="0 10px 30px rgba(0, 0, 0, 0.15)"
                height={{
                  base: "300px",
                }}
                _hover={{
                  transform: "translateY(-10px) scale(1.02)",
                  transition: "transform 0.3s ease-in-out",
                }}
              >
                <Box
                  position="relative"
                  h={{ base: "60px", lg: "80px" }}
                  w="full"
                  flexShrink={0}
                >
                  <Image
                    src={card.icon?.url as string}
                    alt=""
                    fill
                    sizes="100px"
                    style={{ objectFit: "contain" }}
                  />
                </Box>
                <Text
                  color={props.textColor}
                  textAlign="center"
                  fontWeight="bold"
                  pt={5}
                  fontSize={{
                    base: 16,
                    md: 18,
                    xl: 20,
                  }}
                >
                  {card.label}
                </Text>
              </Card>
            </Link>
          </GridItem>
        ))}
      </Grid>
    </SectionTemplate>
  );
};
